import axios from 'axios'
import { debounce } from 'lodash'
import rebuildSelect from ':/functions/rebuild-select'

export default () => ({
  address: {
    type: '',
    name: '',
    address_1: '',
    address_2: '',
    country: '',
    state: '',
    city: '',
    postcode: '',
    phone_number: '',
    is_default: false
  },
  countries: {},
  states: {},
  errors : [],
  canSubmit: false,
  submitting: false,
  init() {

    this.$watch('address.type', debounce((to, from) => {
      if(to !== from) {
        this.updateCountries()
      }
    }, 100))

    this.$watch('address.country', debounce((to, from) => {
      if(to !== from) {
        this.updateStates()
      }
    }, 100))

  },
  open(event, address = null) {

    const params = {}

    if(address) {
      params.address = address
    }

    axios.get(`/account/addresses/ajax/${address ? 'edit' : 'add'}`, {
      params: params
    }).then(response => {
      this.$dispatch('modal-open', {
        content: response.data.template
      })
    })
  },
  submit(event) {

    if(!this.canSubmit) {
      event.preventDefault();
    }

    this.submitting = true;

    this.validate();

    if(this.errors.length) {
      this.submitting = false;
      return
    }

    this.canSubmit = true;
    this.$refs['form'].submit();
  },
  validate() {

    this.errors = [];

    if(this.address.name == '') {
      this.errors.push('Name is required.')
    }

    if(this.address.address_1 == '') {
      this.errors.push('Address is required.')
    }

    if(this.address.city == '') {
      this.errors.push('City is required.')
    }

    if(this.address.country == '' && Object.keys(this.countries).length > 0) {
      this.errors.push('Country is required.')
    }

    if(this.address.state == '' && Object.keys(this.states).length > 0 ) {
      this.errors.push('State is required.')
    }

    if(this.address.postcode == '') {
      this.errors.push('Zip code is required.')
    }
  },
  updateCountries() {

    const select = this.$refs['country'];

    axios.get('/account/addresses/ajax/countries-for-type', {
      params: {
        type: this.address.type
      }
    })
    .then(response => {

      if(response.data.success === false || response.data.countries.length === 0) {
        this.countries = {}
        this.address.country = '';
        return
      }

      this.countries = response.data.countries

      const value = this.countries.hasOwnProperty(this.address.country) ? this.address.country : ''

      rebuildSelect(select, response.data.countries, 'Country', value)

      this.address.country = value;

    })
  },
  updateStates() {

    const select = this.$refs['state'];


    axios.get('/account/addresses/ajax/states-for-country', {
      params: {
        type: this.address.type,
        country: this.address.country
      }
    })
    .then(response => {

      if(response.data.success === false || response.data.states.length === 0) {
        this.states = {}
        this.address.state = ''
        return
      }

      this.states = response.data.states

      const value = this.states.hasOwnProperty(this.address.state) ? this.address.state : ''

      rebuildSelect(select, response.data.states, response.data.label, value)

      this.address.state = value;
    })
  },
})
